export enum UserRole {
  USER = 'ROLE_USER',
  ADMIN = 'ROLE_ADMIN',
  DEVELOPER = 'ROLE_Q',
  SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
}
